import BitesApi from '..';

export const getIcons = (query?: string) => BitesApi.get(`/bite_icons/${query ? `?search=${query}` : ''}`);
